import React from 'react';
import { Search } from 'lucide-react';
import { Dropdown } from '@/shared/components/atoms/Dropdown/Dropdown';

interface SuperOrganizationsFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedPlanFilter: 'all' | 'freemium' | 'scale' | 'enterprise';
  setSelectedPlanFilter: (plan: 'all' | 'freemium' | 'scale' | 'enterprise') => void;
  setPage: (page: number) => void;
}

export function SuperOrganizationsFilters({
  searchTerm,
  setSearchTerm,
  selectedPlanFilter,
  setSelectedPlanFilter,
  setPage
}: SuperOrganizationsFiltersProps) {
  const planOptions = [
    { value: 'all', label: 'All Plans' },
    { value: 'freemium', label: 'Freemium Plan' },
    { value: 'scale', label: 'Scale Plan' },
    { value: 'enterprise', label: 'Enterprise' }
  ];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      flexWrap: 'wrap'
    }}>
      {/* Search Input */}
      <div style={{ position: 'relative', flex: '1 1 300px' }}>
        <Search size={14} style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--admin-card-subtext)' }} />
        <input
          type="text"
          placeholder="Search organizations by name or slug..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage(1);
          }}
          style={{
            width: '100%',
            backgroundColor: 'var(--color-bg-elevated, rgba(255,255,255,0.03))',
            border: '1px solid var(--admin-card-border)',
            borderRadius: '0',
            padding: '9px 16px 9px 40px',
            color: 'var(--admin-card-text)',
            fontSize: '13px',
            fontFamily: "'Inter', sans-serif",
            outline: 'none',
            boxSizing: 'border-box'
          }}
        />
      </div>

      {/* Plan Filter Dropdown */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <div style={{ minWidth: '170px' }}>
          <Dropdown
            value={selectedPlanFilter}
            onChange={(val) => {
              setSelectedPlanFilter(val as any);
              setPage(1);
            }}
            options={planOptions}
            placeholder="All Plans"
            className="w-full kb-dropdown-tall"
          />
        </div>
      </div>
    </div>
  );
}
